import { HttpError } from './HttpError';

/**
 * RestError class for compatibility with log-utils that checks for RestError type
 */
export class RestError extends HttpError {
  restCode?: string;

  constructor(...args: unknown[]) {
    super(...args);
    this.name = 'RestError';
  }
}
RestError.prototype.statusCode = 500;
RestError.prototype.code = 'Error';

/**
 * Bunyan serializer for Fragment errors.
 * Compatible with restify-errors bunyanSerializer behavior.
 *
 * @param err - The error to serialize
 * @returns Serialized error object for logging
 */
export const bunyanSerializer = (
  err: Error | HttpError | RestError | any
): any => {
  if (!err || !err.stack) {
    return err;
  }

  const obj: any = {
    message: err.message,
    name: err.name,
    stack: err.stack,
  };

  // Add HTTP error specific fields if available
  if (err instanceof HttpError) {
    if (err.statusCode) {
      obj.statusCode = err.statusCode;
    }
    if (err.code) {
      obj.code = err.code;
    }
    if (err.body) {
      obj.body = err.body;
    }

    // Add VError info/context
    const { context } = err;
    if (context && Object.keys(context).length > 0) {
      obj.context = context;
    }
  }

  // Add RestError specific fields
  if (err instanceof RestError && err.restCode) {
    obj.restCode = err.restCode;
  }

  return obj;
};
